import { clearDefaultPackage, clearPopulateSpecialPackageItem, clearSelectedClient, clearSelectedPackageToUpdate, clearSpecialPackageItems, clearTypeOfUpdate, clearUpdateClientInfo, resetClientForm, resetIsBooleAndPINDelete, selectClientData, selectClientDataChapels, selectClientDataContactPerson, selectClientExtraPackage, selectCurrentClientId, selectDefaultPackage, selectedIsGenerateNewPINOrDelete, selectPopulatePackageItem, selectSelectedSpecialPackage, selectTypeOfUpdate, selectUpdatePackage, selectUpdatePackageType, setClearSelectedPackage, setIsGenerateNewPINOrDelete } from '../../features/client/clientSlice';
import { useDispatch, useSelector } from 'react-redux';
import { isValidDate } from '../../utils/isValidDate';
import { showToast } from '../../toastify/Toast';
import { useMutationData } from '../api/useMutationData';
import { useClientPopulateWrap } from '../populate/useClientPopulateWrap';
import { handleApiError } from '../../utils/handleApiError';
// import { UpdateClientBody } from '../../types/client';
import { useMasterData } from '../api/useMasterData';
import validateClient from '../client/validation/validateClient';
import validatePackages from '../client/validation/validatePackages';
import { validateSpecialPackage } from '../client/validation/validateSpecialPackage';
import { clearShowDeleteModal, clearTypeOfAdditionalModal, clearTypeOfShowModalType, setTypeOfAdditionalModal } from '../../features/modal/modalSlice';
import { ExtraPackage, UpdateSpecialPackageSchedule } from '../../features/client/clientInterface';
import { UpdateClientBody, UpdateSpecialProductBody } from '../../features/client/clientRequestBody';

export default function useClientAction() {

    const dispatch = useDispatch();
    const clientData = useSelector(selectClientData);
    const clientId = useSelector(selectCurrentClientId);
    const typeOfUpdate = useSelector(selectTypeOfUpdate);
    const isSchedule = typeOfUpdate === 'upSchedule'
    const isChapel = typeOfUpdate === 'upChapel'
    const isContactPerson = typeOfUpdate === 'upAdditionalInformation'
    const { repopulateAll } = useClientPopulateWrap()
    const { generateNewPIN, isLoadingGenerateNewPIN, deleteClient, isLoadingDeleteClient, createClient, isLoadingCreateClient, updateClientInfo, isLoadingUpdateClientInfo, updateClientSpecialPackage, isLoadingUpdateClientSpecialPackage, } = useMutationData()
    const { getBasicPackage } = useMasterData()
    const clientDataChapels = useSelector(selectClientDataChapels);
    const clientContactPerson= useSelector(selectClientDataContactPerson);
    const selectedPackage = useSelector(selectUpdatePackage)
    const packageRedux = useSelector(selectClientExtraPackage);
    const selectedDefaultPackage = useSelector(selectDefaultPackage);
    const specialPackageItem = useSelector(selectPopulatePackageItem);
    const selectedSpecialPackage = useSelector(selectSelectedSpecialPackage);
    const typeOfAction = useSelector(selectedIsGenerateNewPINOrDelete);
    const typeOfPackageToUpdate = useSelector(selectUpdatePackageType);

    const handleCreateNewClient = async () => {
    
        if(!getBasicPackage || !selectedDefaultPackage || !clientData || !clientData.chapels) return
        const error = validateClient(clientData) || validatePackages(clientData) || validateSpecialPackage({selectedSpecialPackage, clientData, specialPackageItem});
        
        if (error) {
            showToast(error, "error");
            return;
        }

        const contactPersons = clientData?.contactPersons?.filter(
            (contact) => contact.name.trim() !== "" || contact.number.trim() !== "09"
        );
        const chapelIDs = clientData.chapels.map((chap) => chap.chapelID)
        const specialPackageItemIDs = specialPackageItem?.map((spc) => spc.productID)
        // const isDefault: boolean = selectedDefaultPackage.id === selectedPackage.id || getBasicPackage.packageID === selectedPackage.id
        const clientInfoFormat = {
            deceasedName: clientData.deceasedName,
            registeredBy: clientData.registeredBy,
            scheduleFrom: clientData.scheduleFrom,
            startTime: clientData.startTime,
            scheduleTo: clientData.scheduleTo,
            endTime: clientData.endTime,
            chapelIDs,
            mobileNo: clientData.mobileNo,
            email: clientData.email,
            ...(contactPersons.length > 0 && { contactPersons }),
            // includeDefaultPackage: isDefault, // required
            // ...(!isDefault && {
            includeDefaultPackage: true, // auto add the basic
            ...(selectedSpecialPackage && {
                specialPackage: {
                    specialPackageID: selectedSpecialPackage.id,
                    items: specialPackageItemIDs,
                    startDate: selectedSpecialPackage.startDate,
                    startTime: selectedSpecialPackage.startTime,
                    endDate: selectedSpecialPackage.endDate,
                    endTime: selectedSpecialPackage.endTime,
                    packageAmount: selectedSpecialPackage.depositAmount,
                    receiptId: selectedSpecialPackage.receiptNumber,
                    receiptDate: selectedSpecialPackage.depositDate,
                },
            }),

            ...(clientData.extraPackages.length > 0 && {
                extraPackages: clientData.extraPackages,
            }),
        }
        try {

            await createClient(clientInfoFormat).unwrap();
            
            showToast("Client created successfully", "success");
            dispatch(clearPopulateSpecialPackageItem())
            dispatch(clearDefaultPackage())
            dispatch(setClearSelectedPackage())
            dispatch(clearSpecialPackageItems())
            dispatch(resetClientForm())
            dispatch(clearTypeOfShowModalType())
        } catch (err: any) {
            const message = err.data.message || "Failed to create client"
            showToast(message, "error");
        }
    };

    const handleGeneratePinOrDeleteClient = async () => {
        if(!clientId || !typeOfAction || typeOfAction === null) return
        try {
            if(typeOfAction === 'generatePIN') {
                const response = await generateNewPIN(clientId).unwrap();
                showToast(response.message, 'success');
                dispatch(setTypeOfAdditionalModal(null))
                return
            }

            if(typeOfAction === 'deleteClient'){
                const response = await deleteClient({ clientID: clientId }).unwrap();
                dispatch(clearShowDeleteModal())
                dispatch(clearTypeOfShowModalType())
                dispatch(clearSelectedClient())
                dispatch(clearTypeOfAdditionalModal())
                showToast(response.message, 'success');
                return
            }
        } catch (error) {
            handleApiError(error, "Delete client failed. Please try again.");
        }
    }

    const handleUpdateSchedule = async () => {
    
        const { scheduleFrom, scheduleTo, startTime, endTime, } = clientData
        
        try {
            
            if(!scheduleFrom || !scheduleTo || !startTime || !endTime) {
                return showToast('Please fill in all required fields.', 'error')
            }
            
            const now = new Date();

            // Today's date (without time)
            const today = new Date(now);
            today.setHours(0, 0, 0, 0);

            // End date (without time)
            const endDate = new Date(scheduleTo);
            endDate.setHours(0, 0, 0, 0);

            // End date cannot be before today
            if (endDate < today) {
                return showToast("End date cannot be earlier than today.", "error");
            }

            // End time cannot exceed 20:59
            if (endTime > "20:59") {
                return showToast("End time must not exceed 08:59 PM.", "error");
            }

            // Check if end date is today
            const isToday =
                endDate.getFullYear() === now.getFullYear() &&
                endDate.getMonth() === now.getMonth() &&
                endDate.getDate() === now.getDate();

            if (isToday) {
                const [endHour, endMinute] = endTime.split(":").map(Number);
                const endTotalMinutes = endHour * 60 + endMinute;

                const currentTotalMinutes =
                    now.getHours() * 60 + now.getMinutes();

                if (endTotalMinutes < currentTotalMinutes) {
                    return showToast(
                        "End time must be the current time or later.",
                        "error"
                    );
                }
            }
            
            if(clientId === undefined) return
            const body = {
                scheduleFrom: scheduleFrom,
                scheduleTo: scheduleTo,
                startTime: startTime,
                endTime: endTime
            }
            await updateClientInfo({ clientId, body}).unwrap()
            showToast('Updated successfully.', 'success');
            repopulateAll() 
            dispatch(clearTypeOfUpdate())
        } catch (error: any) {
            const message = error?.data?.message || "Failed to update schedule."
            handleApiError(error, message);
        }
    };

    const handleUpdateChapel = async () => {
        if(!clientId) return
        try {
            if(clientDataChapels?.length === 0) {
                return showToast("Select at least one chapel.", 'error')
            }
            const chapelIds = clientDataChapels?.map( chap => chap.chapelID);
            const body = { addChapels: chapelIds };
            await updateClientInfo({clientId, body}).unwrap()
            repopulateAll()
            dispatch(clearTypeOfUpdate())
            showToast('Updated successfully.', 'success');
        } catch (error: any) {
            const message = error?.data?.message || "Failed to update chapel."
            handleApiError(error, message);
        }
    }

    const handleUpdateContactPerson = async () => {
    
        try {
            for (const contactP of clientContactPerson || []) {
                const name = contactP.name?.trim();
                const number = contactP.number?.trim();

                if (!name && !number) continue;

                if (!name || !number) {
                    return showToast(
                        "Each contact person must have both a name and a mobile number.",
                        "error"
                    );
                }

                if (!/^09\d{9}$/.test(number)) {
                    return showToast(
                        `Mobile number must start with 09 and be exactly 11 digits (${name}).`,
                        "error"
                    );
                }
            }

            if(clientId === undefined) return
            const body = { contactPersons: clientContactPerson };
            await updateClientInfo({ clientId, body }).unwrap();
            repopulateAll()
            dispatch(clearTypeOfUpdate())
            showToast('Updated successfully.', 'success');
        } catch (error: any) {
            const message = error?.data?.message || "Failed to update contact person."
            handleApiError(error, message);
        }
    };

    const handleUpdateClientPackage = async () => {
        if (!selectedPackage) return;
        if (!clientData) return;
        if (!typeOfPackageToUpdate) return;
        if (clientId === undefined) return;

        const scheduleFrom = clientData.scheduleFrom;
        const scheduleTo = clientData.scheduleTo;
        const clientStartTime = clientData.startTime;
        const clientEndTime = clientData.endTime;

        if (!scheduleFrom || !scheduleTo || !clientStartTime || !clientEndTime) {
            return showToast("Missing client schedule data", "error");
        }

        try {
            const toDateTime = (date: string, time: string) =>
                new Date(`${date}T${time}`);

            const toMinutes = (time: string) => {
                const [hours, minutes] = time.split(":").map(Number);
                return hours * 60 + minutes;
            };

            const chapelStart = toDateTime(scheduleFrom, clientStartTime);
            const chapelEnd = toDateTime(scheduleTo, clientEndTime);

            const {
                packageId,
                packageName,
                startDate,
                startTime,
                endDate,
                endTime,
                clientPackageId,
                downpayment,
                receiptDate,
                receiptId,
            } = selectedPackage;

            if (!startDate || !endDate || !startTime || !endTime) {
                return showToast(
                    `Invalid date or time for package ${packageName}.`,
                    "error"
                );
            }

            if (toMinutes(endTime) > toMinutes("20:59")) {
                return showToast(
                    `The end time must not exceed 8:59 PM for package ${packageName}.`,
                    "error"
                );
            }

            const pkgStart = toDateTime(startDate, startTime);
            const pkgEnd = toDateTime(endDate, endTime);

            if (isNaN(pkgStart.getTime()) || isNaN(pkgEnd.getTime())) {
                return showToast(
                    `Invalid date or time for package ${packageName}.`,
                    "error"
                );
            }

            if (pkgEnd <= pkgStart) {
                return showToast(
                    `End date and time must be after start date and time (${packageName}).`,
                    "error"
                );
            }

            if (pkgStart < chapelStart) {
                return showToast(
                    `Package start date and time must not be earlier than the client's start date and time (${packageName}).`,
                    "error"
                );
            }

            if (pkgEnd > chapelEnd) {
                return showToast(
                    `Package end date and time must not exceed the client's end date and time (${packageName}).`,
                    "error"
                );
            }
            if (typeOfPackageToUpdate === "Cup-Based") {
                const body: UpdateClientBody = {
                    extraPackages: [
                        {
                            clientPackageId,
                            packageId: packageId!,
                            startDate,
                            startTime,
                            endDate,
                            endTime,
                        },
                    ],
                };
                await updateClientInfo({ clientId, body }).unwrap();
            } else {
                if (!receiptId || !receiptDate || !downpayment) {
                    showToast(
                        "Receipt ID, receipt date, and down payment are required.",
                        "error"
                    );
                    return;
                }

                const body: UpdateSpecialProductBody = {
                    specialPackageID: packageId!,
                    startDate,
                    startTime,
                    endDate,
                    endTime,
                    downpayment,
                    receiptId,
                    receiptDate,
                };
                await updateClientSpecialPackage({ clientId, body }).unwrap();
            }
            repopulateAll()
            dispatch(clearSelectedPackageToUpdate());
            showToast("Updated successfully.", "success");
        } catch (error: any) {
            const errorMsg = error?.data?.message || 'Something went wrong'
            showToast(errorMsg, "error");
        }
    };

    const handleUpdateAddPackage = async () => {
        
        if(!clientData) return
        const scheduleFrom = clientData.scheduleFrom
        const scheduleTo = clientData.scheduleTo
        const clientStartTime = clientData.startTime
        const clientEndTime = clientData.endTime

        if (!scheduleFrom || !scheduleTo || !clientStartTime || !clientEndTime) {
            return showToast("Missing client schedule data", "error");
        }

        try {

            if(clientId === undefined) return

            const toDateTime = (date: string, time: string) => new Date(`${date}T${time}`);

            const toMinutes = (t: string) => {
                const [h, m] = t.split(":").map(Number);
                return h * 60 + m;
            };

            const chapelStart = toDateTime(scheduleFrom, clientStartTime);
            const chapelEnd   = toDateTime(scheduleTo, clientEndTime);
            
            for (const pkg of packageRedux) {
                const { startDate, endDate, startTime, endTime, packageName } = pkg;
                
                if (!startDate || !endDate || !startTime || !endTime) {
                    return showToast(`Please provide a complete schedule for package ${packageName}.`, 'error');
                }

                if (toMinutes(endTime) > toMinutes("20:59")) {
                    return showToast(`The end time must not exceed 8:59 PM for package ${packageName}.`, 'error');
                }

                const pkgStart = toDateTime(startDate, startTime);
                const pkgEnd   = toDateTime(endDate, endTime);

                if (isNaN(pkgStart.getTime()) || isNaN(pkgEnd.getTime())) {
                    return showToast(`Invalid date or time for package ${packageName}.`, 'error');
                }

                if (pkgEnd <= pkgStart) {
                    return showToast(`End date and time must be after start date and time (${packageName}).`, 'error');
                }

                if (pkgStart < chapelStart) {
                    return showToast(`Package start date and time must not be earlier than the client's start date and time (${packageName}).`, 'error');
                }

                if (pkgEnd > chapelEnd) {
                    return showToast(`Package end date and time must not exceed the client's end date and time (${packageName}).`, 'error');
                }
            }

            const formatPackages  = packageRedux.map(pkg => ({
                packageId: Number(pkg.packageId),
                startDate: pkg.startDate,
                startTime: pkg.startTime,
                endDate: pkg.endDate,
                endTime: pkg.endTime
            }));
            const body = { extraPackages: formatPackages };
            await updateClientInfo({ clientId, body }).unwrap();
            repopulateAll() 
            showToast('Updated successfully.', 'success');
            dispatch(clearTypeOfUpdate())
            dispatch(clearUpdateClientInfo('extraPack'))
        } catch (error: any) {
            const message = error?.data?.message || "Failed to update contact person."
            handleApiError(error, message);
        }
    }

    const cancelUpdate = () => {
        repopulateAll()
        dispatch(clearTypeOfUpdate())
    }

    const handleCloseViewClient = () => {
        dispatch(clearSelectedClient());
        dispatch(clearTypeOfShowModalType())
        dispatch(clearTypeOfAdditionalModal())
        dispatch(resetIsBooleAndPINDelete())
    }

    const handleCancelGeneratePinOrDeleteClient = () => {
        dispatch(setTypeOfAdditionalModal(null))
        dispatch(setIsGenerateNewPINOrDelete(null))
    }

    return {
        handleCreateNewClient,
        handleGeneratePinOrDeleteClient,
        handleUpdateSchedule,
        handleUpdateChapel,
        handleUpdateContactPerson,
        handleUpdateClientPackage,
        handleUpdateAddPackage,
        
        cancelUpdate,
        handleCloseViewClient,
        handleCancelGeneratePinOrDeleteClient,
        
        isLoadingCreateClient,
        isLoadingUpdateClientInfo,
        isLoadingGenerateNewPIN,
        isLoadingDeleteClient,
        clientDataChapels,

        isSchedule,
        isChapel, 
        isContactPerson,
    }
}
